import { Box, Flex } from "@chakra-ui/react";
import React from "react";
import MarkdownParser from "./MarkdownParser";

export const QuestionPassage: React.FC<{
  badge: any;
  passage: any;
}> = ({ badge, passage }) => {
  return (
    <Box
      // textAlign="justify"
      borderBottomWidth="2xs"
      borderColor="neutral.500"
      pb={8}
      pt={5}
    >
      <Flex flexWrap="wrap">
        {badge}
        <MarkdownParser text={passage} />
      </Flex>
    </Box>
  );
};
